export default {
	props: {
		id: {
			type: String,
			required: true
		},

		selected: {
			type: Boolean,
			required: true
		},

		select: {
			type: Function,
			required: true
		}
	},

	watch: {
		selected() {
			if (this.selected) {
				this.$emit("selected");
			}
		}
	}
};
